import {AdditionalInitialCertificationQuestions, AdditionalQuestions, AdditionalTransferQuestions, Company, ContactPerson, Order, PricingAdjustments, Product, ProductPricing, Standard, TermsAndConditions, TransferQuestions} from "./order.state";

export const initialCompanyState: Company = {
	name: undefined,
	city: undefined,
	street: undefined,
	state: undefined,
	zipCode: undefined,
	country: undefined,
	isMultiSite: undefined,
	additionalParams: {}
};

export const initialContactPerson: ContactPerson = {
	firstName: undefined,
	lastName: undefined,
	email: undefined,
	jobTitle: undefined,
	countryCode: undefined,
	phoneNumber: undefined,
	salesperson: undefined
};

export const initialTermsAndConditions: TermsAndConditions = {
	companyName: undefined,
	firstName: undefined,
	lastName: undefined,
	jobTitle: undefined,
	email: undefined,
	phone: undefined,
	countryCode: undefined,
	estimateAccepted: undefined,
	termsAndConditionsAccepted: undefined
};

export const initialBillingInformation = {
	sameCompanyAndContactPersonAsProvided: true,
	billingCompany: initialCompanyState,
	billingContactPerson: initialContactPerson,
	isPurchaseNumberRequiredForPayment: false,
	purchaseOrderNumber: undefined,
	coverTravelExpenses: false,
	additionalInformation: undefined,
	initial: false
};

export const initialOrderState: Order = {
	auditUuid: undefined,
	orderUuid: undefined,
	orderCorrelationId: undefined,
	orderNumber: undefined,
	activeOrder: undefined,
	status: undefined,
	company: initialCompanyState,
	contactPerson: initialContactPerson,
	products: [],
	termsAndConditions: initialTermsAndConditions,
	certificateFiles: [],
	reportFiles: [],
	additionalQuestionsSubmitted: false,
	creationTimestamp: undefined,
	sentToReviewTimestamp: undefined,
	isSalesLead: undefined,
	isSalesLeadArchived: undefined,
	declineInfo: undefined,
	reviewerChangeComment: undefined,
	assignedClientService: undefined,
	assignedApplicationReviewer: undefined,
	assignedSalesPerson: undefined,
	opportunityId: undefined,
	dataCompared: undefined,
	auditNumber: undefined,
	derivedFromTransfer: false,
	salesLeadSentToClientTimestamp: undefined,
	billingInformations: initialBillingInformation,
	clientCountry: undefined,
	isClientsDataTranslationNeeded: undefined,
	isPricingChanged: undefined,
	takeoverThresholdExceeded: undefined
};

const initialStandardState: Standard = {
	name: undefined,
	hasDekraCertificate: undefined,
	hasCertificate: undefined,
	otherCbName: undefined,
	customCb: undefined
};

const initialPricingAdjustments: PricingAdjustments = {
	dailyRate: undefined,
	complexityFactor: undefined,
	auditEffort: undefined,
	itComplexity: undefined,
	businessComplexity: undefined,
	risk: undefined,
	fees: []
};

const initialProductPricing: ProductPricing = {
	totalPrice: undefined,
	totalAuditTime: undefined,
	annualPricings: [],
	dailyRate: undefined,
	pricingAdjustments: initialPricingAdjustments,
	risk: undefined,
	complexityFactor: undefined,
	auditEffort: undefined,
	businessComplexity: undefined,
	itComplexity: undefined,
	appliedDiscount: undefined,
	calculatedDiscount: undefined
};

export const initialAdditionalTransferQuestions: AdditionalTransferQuestions = {
	isCurrentCertificationBodyAccredited: undefined,
	expirationDate: undefined,
	hasCorrectiveActionPlans: undefined,
	hasOpenNonConformities: undefined,
	lastAuditPerformedDate: undefined,
	numberOfMajorNonConformities: undefined,
	numberOfMinorNonConformities: undefined,
	transferReason: undefined,
};

export const initialAdditionalInitialCertificationQuestions: AdditionalInitialCertificationQuestions = {
	preAuditRequested: undefined,
	desiredPreAuditDate: undefined,
	desiredStage1AuditDate: undefined
};

export const initialAdditionalQuestion: AdditionalQuestions = {
	binaryQuestions: [],
	textQuestions: [],
	desiredNextAuditDate: undefined,
	outsourcedProcesses: [],
	transferQuestions: initialAdditionalTransferQuestions
};

export const initialProductState: Product = {
	accreditationBody: undefined,
	standard: initialStandardState,
	companyDescription: undefined,
	employees: undefined,
	scopeDescriptionNeedsNarrowing: undefined,
	employeesWithinScope: undefined,
	scopeDescription: undefined,
	partTimeOrTempEmployeesIncluded: undefined,
	employeesCountDescription: undefined,
	priceFactors: [],
	estimateQuestions: [],
	recertificationQuestions: undefined,
	transferQuestions: {lastAuditEvent: undefined} as TransferQuestions,
	scopes: [],
	shifts: undefined,
	pricing: initialProductPricing,
	additionalQuestions: initialAdditionalQuestion,
	catastrophicRisk: undefined,
	currentAuditEvent: undefined,
	followingAuditEvent: undefined,
	auditorFirstName: undefined,
	auditorLastName: undefined
};
